import React from "react";
import Card from "../components/Card";
import WithFetchShoppingCarts from "./WithFetchShoppingCarts";
import _ from "lodash/fp";
import Loading from "../components/Loading";
import TryAgain from "../components/TryAgain";
import ShoppingCartTable from "../components/ShoppingCartTable";

const OrderList = WithFetchShoppingCarts(
  ({ shoppingCarts, loading, success, failure, role }) => {
    if (loading) {
      return <Loading label="Loading orders" />;
    }
    if (failure) {
      return <TryAgain label={failure} />;
    }
    if (success) {
      if (!_.isEmpty(shoppingCarts)) {
        return <ShoppingCartTable role={role} shoppingCarts={shoppingCarts} />;
      } else {
        return <h4>No available orders</h4>;
      }
    }
    return null;
  }
);

const Orders = () => {
  return (
    <div className="row">
      <div className="col">
        <Card
          title={<h3 className="title">Orders</h3>}
          content={<OrderList />}
        />
      </div>
    </div>
  );
};

export default Orders;
